import React from "react";
import {
    FormControl,
    Select,
    MenuItem,
    Box,
    Typography,
    Chip,
} from "@mui/material";
import Iconify from "../components/iconify";
import {
    PAYOUT_FORMATS,
    getChipColor,
    getChipLabel,
    getPayoutDescription,
    renderPayoutFormat,
} from "src/utils/challengeUtils";

export default function PayoutFormatSelect({
    value,
    onChange,
    disabled = false,
    guaranteeValues = {},
    hasEmptyState = false,
    ...props
}) {
    return (
        <FormControl fullWidth {...props}>
            <Select
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
                renderValue={() => renderPayoutFormat(value, guaranteeValues, hasEmptyState)}
                disabled={disabled}
                sx={{
                    borderRadius: 5,
                    backgroundColor: disabled ? "#f5f5f5" : "white",
                    "& .MuiSelect-icon": {
                        color: "#667eea",
                    },
                }}
            >
                {PAYOUT_FORMATS.map((option) => (
                    <MenuItem key={option} value={option}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                width: "100%",
                            }}
                        >
                            <Chip
                                label={getChipLabel(option)}
                                size="small"
                                sx={{
                                    backgroundColor: getChipColor(option),
                                    color: "white",
                                    fontWeight: 500,
                                }}
                            />
                            <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{ flex: 1 }}
                            >
                                {getPayoutDescription(option)}
                            </Typography>
                            {option && option.startsWith("GRT-") && (
                                <Iconify
                                    icon="eva:settings-2-outline"
                                    sx={{
                                        color: "#667eea",
                                        width: 16,
                                        height: 16,
                                    }}
                                />
                            )}
                        </Box>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}